import React from 'react';
import './Hero.css';

const Hero: React.FC = () => {
  return (
    <section className="hero">
      <div className="background-gradient" />
      <div className="hero-content">
        <div className="hero-logo">
          <img 
            src="/assets/logos/siorm-logo-horizontal.svg" 
            alt="SIORM Drones" 
            className="hero-logo-image"
          />
        </div>
        <h1 className="hero-title">
          Capturamos el mundo
          <span className="hero-highlight"> desde las alturas</span>
        </h1>
        <p className="hero-subtitle">
          Servicios profesionales de drones para mapeo, inspección, 
          fotografía aérea y más. Tecnología de vanguardia al servicio 
          de sus proyectos.
        </p>
        <div className="hero-buttons">
          <a href="#gallery" className="btn-primary">Ver Trabajos</a>
          <a href="#contact" className="btn-secondary">Contactar</a>
        </div>
      </div>
      
      {/* Scroll indicator */}
      <div className="scroll-indicator">
        <div className="scroll-arrow"></div>
        <span>Desliza para explorar</span>
      </div>
      
      <div className="hero-background">
        <div className="hero-gradient"></div>
      </div>
    </section>
  );
};

export default Hero;